<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <CDropdownToggle>
        Hi, {{ username }}
    </CDropdownToggle>
    <CDropdownMenu>
      <CDropdownItem @click="logout">
        <CIcon :icon="cilAccountLogout" class="me-2" />
        <div style="display:inline;">Logout</div>
      </CDropdownItem>
    </CDropdownMenu>
  </CDropdown>
</template>

<script>
import { INACTIVE_USER_TIME_THRESHOLD, USER_ACTIVITY_THROTTLER_TIME, REFRESH_TOKEN_TIME_THRESHOLD } from "@/helpers/constants"
import userService from '@/services/userService'
import { CDropdownItem, CDropdown, CDropdownMenu, CDropdownToggle } from "@coreui/vue";
import { cilAccountLogout } from '@coreui/icons'
import { CIcon } from '@coreui/icons-vue'

export default {
  name: 'HeaderAccount',
  components: {
    CDropdown,
    CDropdownItem,
    CDropdownMenu,
    CDropdownToggle,
    CIcon,
  },
  data () {
    return { 
      username: '',
      userActivityThrottlerTimeout: null,
      userActivityTimeout: null,
      cilAccountLogout,
    }
  },
  created() {
    this.fetchData()
  },
  beforeMount() {
    this.activateActivityTracker();
  },
  beforeUnmount() {
    this.deactivateActivityTracker();
    clearTimeout(this.userActivityTimeout);
    clearTimeout(this.userActivityThrottlerTimeout);
  },
  methods: {
    logout() {
      localStorage.clear()
      location.reload(true)
    },
    fetchData() {
      this.username = localStorage.name

      this.interval = setInterval(() => this.refreshToken(), REFRESH_TOKEN_TIME_THRESHOLD);
    },
    activateActivityTracker() {
      window.addEventListener("mousemove", this.userActivityThrottler)
      window.addEventListener("scroll", this.userActivityThrottler)
      window.addEventListener("keydown", this.userActivityThrottler)
      window.addEventListener("resize", this.userActivityThrottler)
    },
    deactivateActivityTracker() {
      window.removeEventListener("mousemove", this.userActivityThrottler)
      window.removeEventListener("scroll", this.userActivityThrottler)
      window.removeEventListener("keydown", this.userActivityThrottler)
      window.removeEventListener("resize", this.userActivityThrottler)
    },
    resetUserActivityTimeout() {
      clearTimeout(this.userActivityTimeout)

      this.userActivityTimeout = setTimeout(() => {
        this.userActivityThrottler()
        this.inactiveUserAction()
      }, INACTIVE_USER_TIME_THRESHOLD)
    },
    userActivityThrottler() {

      if (!this.userActivityThrottlerTimeout) {
        this.userActivityThrottlerTimeout = setTimeout(() => {
          this.resetUserActivityTimeout()
          clearTimeout(this.userActivityThrottlerTimeout)
          this.userActivityThrottlerTimeout = null
        }, USER_ACTIVITY_THROTTLER_TIME)
      }
    },
    inactiveUserAction() {
      //logout user here
      this.logout()
    },
    refreshToken() {
      userService.refreshToken()
        .then(result => {
          localStorage.token = result.token
        })
    }
  }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>